import { createElement, PropTypes } from 'rlink-react';
import Picture from 'rlink-repos/components/Picture';

export default function Profile ({profileData}) {
  return (
    <article className="node node-team-member node-teaser">
      <div className="image">
        {profileData.mainImageFormats.src !== '' && (
          <Picture
            src={profileData.mainImageFormats.src}
            widths={profileData.mainImageFormats.widths}
            heights={profileData.mainImageFormats.heights}
            formats={profileData.mainImageFormats.formats} />
        )}
      </div>
      <h5 className="node-title noline">{profileData.name}</h5>
      <div className="field field-name-field-job-title field-type-text field-label-hidden subheader field-wrapper">{profileData.jobTitle}</div>
      <hr />
      <div className="body text-secondary" dangerouslySetInnerHTML={{__html: profileData.description}} />
      <div className="field field-name-field-social-links field-type-link-field field-label-hidden field-wrapper">
        <a
          href={profileData.linkedIn}
          className="fi-social-linkedin"
          target="_blank"
          rel="nofollow">
          {`${profileData.linkedIn.substring(0, 60)}${profileData.linkedIn.length > 60 ? '...' : ''}`}
        </a>
      </div>
    </article>
  );
}

Profile.propTypes = {
  profileData: PropTypes.shape({
    mainImageFormats: PropTypes.shape({
      src: PropTypes.string,
      widths: PropTypes.arrayOf(PropTypes.number),
      heights: PropTypes.arrayOf(PropTypes.number),
      formats: PropTypes.arrayOf(PropTypes.shape({
        contentType: PropTypes.string,
        fileExt: PropTypes.string,
      })),
    }),
    name: PropTypes.string,
    title: PropTypes.string,
    jobTitle: PropTypes.string,
    description: PropTypes.string,
    linkedIn: PropTypes.string,
    priority: PropTypes.number,
  }),
};



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/AboutUs/Profile.jsx